import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import confetti from "canvas-confetti";
import client from "../lib/api";
import { toast } from "sonner";
import { playLeadAlertSound, playSignupFanfare } from "../lib/cashSound";

export const LeadAlertWatcher = () => {
  const navigate = useNavigate();
  const sinceRef = useRef(localStorage.getItem("fp_lead_seen") || new Date().toISOString());
  const signupSinceRef = useRef(localStorage.getItem("fp_signup_seen") || new Date().toISOString());

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const { data } = await client.get(
          `/admin/lead-alerts/new-since?since=${encodeURIComponent(sinceRef.current)}`
        );
        if (cancelled || !data.now) return;
        sinceRef.current = data.now;
        localStorage.setItem("fp_lead_seen", data.now);
        const leads = data.leads || [];
        if (!leads.length) return;
        playLeadAlertSound();
        leads.slice(0, 3).forEach((l) => {
          const fb = l.bucket === "facebook_paid";
          const heat = l.heat_label
            ? `${l.heat_label === "HOT" ? "🔥" : l.heat_label === "WARM" ? "🌡️" : "❄️"} ${l.heat_label} ${l.heat}/100 · `
            : "";
          toast(fb ? "FACEBOOK AD LEAD" : "New lead just arrived", {
            description: `${heat}${l.company_name || l.contact_name || "A trucker"}${fb ? " — your ad money is working" : ""}`,
            duration: 15000,
            action: { label: "Open Inbox", onClick: () => navigate("/app/inbox") },
            ...(fb
              ? { style: { border: "1px solid #3b82f6", background: "#0b1a33", color: "#dbeafe" } }
              : { style: { border: "1px solid #FF5A1F55" } }),
          });
        });
        if (leads.length > 3) {
          toast(`+${leads.length - 3} more new leads`, {
            duration: 10000,
            action: { label: "Open Inbox", onClick: () => navigate("/app/inbox") },
          });
        }
      } catch {
        /* poll errors are silent */
      }
    };

    const checkSignups = async () => {
      try {
        const { data } = await client.get(
          `/admin/signup-alerts/new-since?since=${encodeURIComponent(signupSinceRef.current)}`
        );
        if (cancelled || !data.now) return;
        signupSinceRef.current = data.now;
        localStorage.setItem("fp_signup_seen", data.now);
        const signups = data.signups || [];
        if (!signups.length) return;
        playSignupFanfare();
        confetti({
          particleCount: 160,
          spread: 90,
          origin: { y: 0.2 },
          colors: ["#FFD700", "#FFC300", "#FF5A1F", "#ffffff"],
        });
        signups.slice(0, 3).forEach((s) => {
          const who = s.company_name || s.contact_name || "A lead";
          toast("🏆 SIGNUP! THEY'RE IN", {
            description: `${who} just created an account — call while they're hot${s.phone ? `: ${s.phone}` : ""}`,
            duration: 20000,
            action: { label: "Open Inbox", onClick: () => navigate("/app/inbox") },
            style: { border: "1px solid #FFD700", background: "#1a1503", color: "#fde68a" },
          });
        });
      } catch {
        /* poll errors are silent */
      }
    };

    const tick = () => { check(); checkSignups(); };
    tick();
    const t = setInterval(tick, 30000);
    return () => {
      cancelled = true;
      clearInterval(t);
    };
  }, [navigate]);

  return null;
};
